<template>
  <VTooltip
    v-model="showToolTip"
    v-bind="$props"
    :max-width="this.width"
    close-delay="1000"
    transition="scale-transition"
    style="opacity:1.0 !important;color:black !important;"
    :bottom="bottom"
    color="#ffffff"
  >
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <span
          class="psTooltip"
          @mouseout="checkToolTipMouseOut"
        >i</span>
      </span>
    </template>
    <div
      style="color:black !important"
      @mouseover="mouseOver"
      @mouseleave="mouseLeave"
    >
     <span v-html="text" style="color:black !important"></span>
    </div>
  </VTooltip>
</template>
<script>
export default {
    name: "PsTooltip",

    props: {
        bottom: {
            type: Boolean,
            required: false,
            default: true
        },
        color: {
            type: String,
            required: false,
            default: "white"
        },
        text: {
            type: String,
            required: false,
            default: ""
        },
        width:{
            type: String,
            required: false,
            default: '200px'
        }
    },
    data() {
        return {
            showToolTip: false,
            popupHover: false
        };
    },
    methods: {
        checkToolTipMouseOut(e) {
            setTimeout(() => { this.showToolTip = this.popupHover; }, 400);
        },
        mouseOver() {
            this.popupHover = true;
            this.showToolTip = true;
        },
        mouseLeave() {
            setTimeout(() => {
                this.showToolTip = false;
                this.popupHover = false;
            }, 400);
        }
    }
};
</script>
<style>
.p4-report .psTooltip {
  background-color: #467fa5 !important;
  color: #ffffff;
  border-radius: 50%;
  font-weight: bold;
  padding: 0px 4px;
  font-style: italic;
  font-family: serif;
  font-size: 0.8em;
  opacity:1.0 !important;
}
.v-tooltip__content {
    opacity: 1.0 !important;
    border-radius:5px;
    border:1px solid #467fa5 !important;
}
</style>
